import {useBillingProviders} from '../hooks/useBillingProviders.ts';
import {FieldProps} from 'formik';
import {FormikGenericCombobox} from '@flexinet/ui-components';
import {BillingProvider} from "../types.ts";
import {TextInputProps} from "@mantine/core";

// Lists `items`, the loaded rows before any table search or status filter. The query
// fetches on mount; this used to also call fetchRecords() from a useEffect keyed on a
// function recreated every render, which invalidated the whole ['billing-providers'] root
// on every keystroke in the host form.
export const BillingProvidersAutocomplete = (props: FieldProps & TextInputProps) => {

    const {
        items: records,
        loading,
    } = useBillingProviders();

    return (
        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: BillingProvider) => (record.name)}
            getSelectedOption={(record: BillingProvider) => record.name}
            isLoading={loading}
            {...props}
        />
    );

};
